import * as Yup from 'yup';

export const profileSchema = Yup.object().shape({
  ownerName: Yup.string()
    .min(2, 'Owner Name must be at least 2 characters')
    .required('Owner Name is required'),
  fatherName: Yup.string()
    .min(2, "Father's Name must be at least 2 characters")
    .required("Father's Name is required"),
  cnic: Yup.string()
    .matches(
      /^\d{5}-\d{7}-\d{1}$/,
      "CNIC must be in the format XXXXX-XXXXXXX-X"
    )
    .required("CNIC is required"),
  contactNumber: Yup.string()
    .matches(/^\d{9}$/, 'Contact Number must be exactly 11 digits')
    .required('Contact Number is required'),
  alternateNumber: Yup.string()
    .matches(/^\d{9}$/, 'Alternate Number must be exactly 11 digits')
    .nullable(),
  currentAddress: Yup.string()
    .min(10, 'Address must be at least 10 characters')
    .required('Current Address is required'),
  permanentAddress: Yup.string()
    .min(10, 'Address must be at least 10 characters')
    .required('Permanent Address is required'),
  occupation: Yup.string()
    .required('Occupation is required'),
  sourceOfIncome: Yup.string()
    .required('Source of Income is required'),
  monthlyIncome: Yup.string()
    .nullable(),
  // signature: Yup.string()
  // .required('Signature is required')
});

// Occupation options
export const occupationOptions = [
  { value: 'business_owner', label: 'Business Owner' },
  { value: 'property_dealer', label: 'Property Dealer' },
  { value: 'government_employee', label: 'Government Employee' },
  { value: 'private_employee', label: 'Private Employee' },
  { value: 'retired', label: 'Retired' },
  { value: 'self_employed', label: 'Self Employed' },
  { value: 'contractor', label: 'Contractor' },
  { value: 'doctor', label: 'Doctor' },
  { value: 'engineer', label: 'Engineer' },
  { value: 'lawyer', label: 'Lawyer' },
  { value: 'teacher', label: 'Teacher' },
  { value: 'other', label: 'Other' },
];

// Source of Income options
export const sourceOfIncomeOptions = [
  { value: 'rental_income', label: 'Rental Income (Buildings/Properties)' },
  { value: 'business', label: 'Business' },
  { value: 'salary', label: 'Salary/Job' },
  { value: 'pension', label: 'Pension' },
  { value: 'agriculture', label: 'Agriculture/Farming' },
  { value: 'investments', label: 'Investments/Dividends' },
  { value: 'freelancing', label: 'Freelancing' },
  { value: 'remittance', label: 'Foreign Remittance' },
  { value: 'mixed', label: 'Multiple Sources' },
  { value: 'other', label: 'Other' },
];

// Which Source of Income options are relevant for each Occupation.
// Occupations not listed here (e.g. 'other') show the full list.
export const occupationToIncomeMap = {
  business_owner: ['business', 'mixed', 'other'],
  property_dealer: ['business', 'rental_income', 'mixed', 'other'],
  government_employee: ['salary', 'other'],
  private_employee: ['salary', 'other'],
  retired: ['pension'],
  self_employed: ['business', 'freelancing', 'mixed', 'other'],
  contractor: ['business', 'freelancing', 'other'],
  doctor: ['salary', 'business', 'other'],
  engineer: ['salary', 'business', 'other'],
  lawyer: ['salary', 'business', 'other'],
  teacher: ['salary', 'other'],
};

export const getSourceOfIncomeOptionsFor = (occupation) => {
  const allowed = occupationToIncomeMap[occupation];
  if (!allowed) return sourceOfIncomeOptions;
  return sourceOfIncomeOptions.filter((opt) => allowed.includes(opt.value));
};

// Monthly Income Range options
export const monthlyIncomeOptions = [
  { value: 'below_50k', label: 'Below 50,000 PKR' },
  { value: '50k_100k', label: '50,000 - 100,000 PKR' },
  { value: '100k_200k', label: '100,000 - 200,000 PKR' },
  { value: '200k_500k', label: '200,000 - 500,000 PKR' },
  { value: '500k_1m', label: '500,000 - 1,000,000 PKR' },
  { value: 'above_1m', label: 'Above 1,000,000 PKR' },
  { value: 'prefer_not_to_say', label: 'Prefer not to say' },
];
